import { useParams, useNavigate } from "react-router-dom";
import Stepper from "../../components/Stepper";

export default function TermoVisitante() {
  const { id } = useParams();
  const navigate = useNavigate();

  const termos = {
    "feinsul-2026": "/imagens/termos/TermoVisitanteFeinsul.png",
    "expo-agro-2026": "/imagens/termos/TermoVisitanteFeinsul.png",
  };

  const handleContinuar = () => {
    navigate(`/evento/${id}/visitante`);
  };

  const termoAtual = termos[id];

  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/FundoGeral.png")' }}
    >
      <div className="termo-wrapper">
        <div className="page">

          <div className="termo-container">
            <h1>Termo de Credenciamento</h1>
            <p>
              Antes de prosseguir, leia atentamente o termo de credenciamento
              abaixo. Ao clicar em "Concordar e continuar", você será direcionado
              para a página de credenciamento.
            </p>
          </div>

          {termoAtual ? (
            <img
              src={termoAtual}
              alt="Termo visitante"
              className="termo-img"
            />
          ) : (
            <p style={{ color: "red" }}>
              Termo não configurado para este evento.
            </p>
          )}

          <button onClick={handleContinuar} className="link-button">
            Concordar e continuar
          </button>

        </div>

        <Stepper etapaAtual={2} />
      </div>
    </div>
  );
}